import React from 'react';
import { useAuth } from '../../../context/AuthContext';
import DeluxeConnectCard from '../../../deluxe/components/DeluxeConnectCard';
import BackToPaymentSettings from '../components/BackToPaymentSettings';

const DeluxeSettings = ({ onBackToPayments }) => {
  const { companyData } = useAuth();

  return (
    <div className="deluxe-settings-page">
      {onBackToPayments && <BackToPaymentSettings onBack={onBackToPayments} />}
      <DeluxeConnectCard companyId={companyData?.id} />
    </div>
  );
};

export default DeluxeSettings;
